<template>


  <div
    v-show="showing"
    class="bg-filters fixed rounded-md ml-16 px-4 py-2 shadow-2xl"
  >
    <div class="scrollable-items overflow-auto">
      <div class="vld-parent">
        <loading :active.sync="isLoading" 
        :is-full-page="fullPage"></loading>
      </div>

      <div class="text-left pb-2 pt-2">
        <div class="flex items-center">
          <button
            class="focus:outline-none"
            @click="collapseFilter({ type: 'projects'})"
            v-if="collapsed['projects']"
          >
            <svg 
              xmlns="http://www.w3.org/2000/svg"
              class="h-6 w-6 fill-current text-gray-700 hover:text-orange-500"
              viewBox="0 0 24 24"
            >
              <path d="M0 0h24v24H0V0z" fill="none" opacity= "0.87"/>
              <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6-6-6z"/>
            </svg>
          </button>
          <button
            class="focus:outline-none"
            @click="collapseFilter({ type: 'projects'})"
            v-else
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-6 w-6 fill-current text-gray-700 hover:text-orange-500"
              viewBox="0 0 24 24"
            >
              <path d="M24 24H0V0h24v24z" fill="none" opacity=".87" />
              <path d="M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6-1.41-1.41z" />
            </svg>
          </button>
          <span class="font-sans text-xl font-semibold text-gray-600 px-2">PROYECTOS</span>
          <button
            title="Limpiar filtros de proyectos"
            class="focus:outline-none"
            @click="clearFilter('projects')"
          >
            <svg
              class="h-6 w-6 fill-current text-red-500 hover:text-red-700"
              viewBox="0 0 32 32"  
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="m30 11.414-1.414-1.414-4.586 4.586-4.586-4.586-1.414 1.414 4.586 4.586-4.586 4.585 1.415 1.415 4.585-4.586 4.587 4.586 1.413-1.413-4.586-4.587z"/>
              <path d="m4 4a2 2 0 0 0 -2 2v3.1709a2 2 0 0 0 .5859 1.4145l7.4141 7.4146v8a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2v-2h-2v2h-4v-8.8291l-.5859-.5855-7.4141-7.4145v-3.1709h20v2h2v-2a2 2 0 0 0 -2-2z"/>
              <path d="m0 0h32v32h-32z" fill="none"/>
            </svg>
          </button>

          <button
            title="Buscar por nombre de proyecto"
            class="focus:outline-none"
            @click="toggleSearch({type: 'projects'})"
          >
            <svg
              class="h-6 w-6 fill-current text-gray-500 hover:text-gray-700"
              viewBox="0 0 22 22"  
              xmlns="http://www.w3.org/2000/svg"
            >
              <<path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"/>
              <path d="m0 0h32v32h-32z" fill="none"/>
            </svg>
          </button>
          
        </div>
        <ul style="padding-left:30px;" class="mt-2" v-bind:class="[collapsed['projects'] ? 'hidden' : 'block']">
          <li v-if="showSearch[`projects`]">
            <label class="inline-flex items-center cursor-pointer text-gray-700 font-sans font-medium w-full pr-3" >
              <input
                type="text"
                ref="projectsSearch"
                v-model="search['projects']"
                placeholder="Búsqueda de proyecto por nombre"
                class="w-full appearance-none border rounded py-2 px-3 mb-3 text-gray-900 bg-gray-200 focus:outline-none focus:bg-white focus:border-teal-500"
                @input="searchByName({ text: search['projects'], type: 'projects' })"
              />
            </label>
          </li>
          <template v-for="project in projects">
            <li :key="project.id">
              <label class="inline-flex items-center cursor-pointer text-gray-700 font-sans font-medium">
                <input
                  type="checkbox"
                  class="form-checkbox"
                  :id="'project' + project.id"
                  name="project"
                  :value="project.id"
                  v-model="selectedProject"

                  @change="fetchDataByFilter(project, $event)" 
                />
                <span class="ml-2 mr-3">{{ project.nombre }}</span>
              </label>
            </li>
          </template>
        </ul>
      </div>
      <div class="text-left pb-2 pt-2">
        <div class="flex items-center">
          <button
            class="focus:outline-none"
            @click="collapseFilter({ type: 'categories'})"
            v-if="collapsed['categories']"
          >
            <svg 
              xmlns="http://www.w3.org/2000/svg"
              class="h-6 w-6 fill-current text-gray-700 hover:text-orange-500"
              viewBox="0 0 24 24"
            >
              <path d="M0 0h24v24H0V0z" fill="none" opacity= "0.87"/>
              <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6-6-6z"/>
            </svg>
          </button>
          <button
            class="focus:outline-none"
            @click="collapseFilter({ type: 'categories'})"
            v-else
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-6 w-6 fill-current text-gray-700 hover:text-orange-500"
              viewBox="0 0 24 24"
            >
              <path d="M24 24H0V0h24v24z" fill="none" opacity=".87" />
              <path d="M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6-1.41-1.41z" />
            </svg>
          </button>
          <span class="font-sans text-xl font-semibold text-gray-600 px-2">CATEGORÍAS</span>
          <button
            title="Eliminar filtro de categorías"
            class="focus:outline-none"
            @click="clearFilter('categories')"
          >
            <svg
              class="h-6 w-6 fill-current text-red-500 hover:text-red-700"
              viewBox="0 0 32 32"  
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="m30 11.414-1.414-1.414-4.586 4.586-4.586-4.586-1.414 1.414 4.586 4.586-4.586 4.585 1.415 1.415 4.585-4.586 4.587 4.586 1.413-1.413-4.586-4.587z"/>
              <path d="m4 4a2 2 0 0 0 -2 2v3.1709a2 2 0 0 0 .5859 1.4145l7.4141 7.4146v8a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2v-2h-2v2h-4v-8.8291l-.5859-.5855-7.4141-7.4145v-3.1709h20v2h2v-2a2 2 0 0 0 -2-2z"/>
              <path d="m0 0h32v32h-32z" fill="none"/>
            </svg>
          </button>

          <button
            title="Buscar por nombre de categorìa"
            class="focus:outline-none"
            @click="toggleSearch({type: 'categories'})"
          >
            <svg
              class="h-6 w-6 fill-current text-gray-500 hover:text-gray-700"
              viewBox="0 0 22 22"  
              xmlns="http://www.w3.org/2000/svg"
            >
              <<path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"/>
              <path d="m0 0h32v32h-32z" fill="none"/>
            </svg>
          </button>

        </div>
        <ul style="padding-left:30px;"
          class="mt-2"
          v-bind:class="[collapsed['categories'] ? 'hidden' : 'block']"
        >
          <li v-if="showSearch[`categories`]">
            <label class="inline-flex items-center cursor-pointer text-gray-700 font-sans font-medium w-full pr-3" >
              <input
                type="text"
                ref="categoriesSearch"
                v-model="search['categories']"
                placeholder="Búsqueda de categorìas por nombre"
                class="w-full appearance-none border rounded py-2 px-3 mb-3 text-gray-900 bg-gray-200 focus:outline-none focus:bg-white focus:border-teal-500"
                @input="searchByName({ text: search['categories'], type: 'categories' })"
              />
            </label>
          </li>
          <template v-for="category in categories">
            <li :key="category.id">
              <label class="inline-flex items-center cursor-pointer text-gray-700 font-sans font-medium">
                <input
                  type="checkbox"
                  class="form-checkbox"
                  :id="'category' + category.id"
                  name="category"
                  :value="category.id"
                  v-model="selectedCategory"
                  @change="fetchDataByFilter(category, $event)"
                />
                <span class="ml-2 mr-3">{{ category.nombre }}</span>
              </label>
            </li>
          </template>
        </ul>
      </div>
      <div class="text-left pb-2 pt-2">
        <div class="flex items-center">
          <button
            class="focus:outline-none"
            @click="collapseFilter({ type: 'subcategories'})"
            v-if="collapsed['subcategories']"
          >
            <svg 
              xmlns="http://www.w3.org/2000/svg"
              class="h-6 w-6 fill-current text-gray-700 hover:text-purple-500"
              viewBox="0 0 24 24"
            >
              <path d="M0 0h24v24H0V0z" fill="none" opacity= "0.87"/>
              <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6-6-6z"/>
            </svg>
          </button>
          <button
            class="focus:outline-none"
            @click="collapseFilter({ type: 'subcategories'})"
            v-else
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-6 w-6 fill-current text-gray-700 hover:text-orange-500"
              viewBox="0 0 24 24"
            >
              <path d="M24 24H0V0h24v24z" fill="none" opacity=".87" />
              <path d="M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6-1.41-1.41z" />
            </svg>
          </button>
          <span class="font-sans text-xl font-semibold text-gray-600 px-2">SUBCATEGORÍAS</span>
          <button
            title="Eliminar filtro de subcategorías"
            class="focus:outline-none"
            @click="clearFilter('subcategories')"
          >
            <svg
              class="h-6 w-6 fill-current text-red-500 hover:text-red-700"
              viewBox="0 0 32 32"  
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="m30 11.414-1.414-1.414-4.586 4.586-4.586-4.586-1.414 1.414 4.586 4.586-4.586 4.585 1.415 1.415 4.585-4.586 4.587 4.586 1.413-1.413-4.586-4.587z"/>
              <path d="m4 4a2 2 0 0 0 -2 2v3.1709a2 2 0 0 0 .5859 1.4145l7.4141 7.4146v8a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2v-2h-2v2h-4v-8.8291l-.5859-.5855-7.4141-7.4145v-3.1709h20v2h2v-2a2 2 0 0 0 -2-2z"/>
              <path d="m0 0h32v32h-32z" fill="none"/>
            </svg>
          </button>

          <button
            title="Buscar por nombre de subcategorìa"
            class="focus:outline-none"
            @click="toggleSearch({type: 'subcategories'})"
          >
            <svg
              class="h-6 w-6 fill-current text-gray-500 hover:text-gray-700"
              viewBox="0 0 22 22"  
              xmlns="http://www.w3.org/2000/svg"
            >
              <<path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"/>
              <path d="m0 0h32v32h-32z" fill="none"/>
            </svg>
          </button>
          
        </div>
        <ul style="padding-left:30px;"
          class="mt-2"
          v-bind:class="[collapsed['subcategories'] ? 'hidden' : 'block']"
        >
          <li v-if="showSearch[`subcategories`]">
            <label class="inline-flex items-center cursor-pointer text-gray-700 font-sans font-medium w-full pr-3" >
              <input
                type="text"
                ref="subcategoriesSearch"
                v-model="search['subcategories']"
                placeholder="Búsqueda de subcategorìa por nombre"
                class="w-full appearance-none border rounded py-2 px-3 mb-3 text-gray-900 bg-gray-200 focus:outline-none focus:bg-white focus:border-teal-500"
                @input="searchByName({ text: search['subcategories'], type: 'subcategories' })"
              />
            </label>
          </li>
          <template v-for="subcategory in subcategories">
            <li :key="subcategory.id">
              <label class="inline-flex items-center cursor-pointer text-gray-700 font-sans font-medium">
                <input
                  type="checkbox"
                  class="form-checkbox"
                  :id="'subcategory' + subcategory.id"
                  name="subcategory"
                  :value="subcategory.id"
                  v-model="selectedSubcategory"
                  @change="fetchDataByFilter(subcategory, $event)"
                />
                <span class="ml-2 mr-3">{{ subcategory.nombre }}</span>
              </label>
            </li>
          </template>
        </ul>
      </div>
      <div class="text-left pb-2 pt-2">
        <div class="flex items-center">
          <button
            class="focus:outline-none"
            @click="collapseFilter({ type: 'types'})"
            v-if="collapsed['types']"
          >
            <svg 
              xmlns="http://www.w3.org/2000/svg"
              class="h-6 w-6 fill-current text-gray-700 hover:text-orange-500"
              viewBox="0 0 24 24"
            >
              <path d="M0 0h24v24H0V0z" fill="none" opacity= "0.87"/>
              <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6-6-6z"/>
            </svg>
          </button>
          <button
            class="focus:outline-none"
            @click="collapseFilter({ type: 'types'})"
            v-else
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-6 w-6 fill-current text-gray-700 hover:text-orange-500"
              viewBox="0 0 24 24"
            >
              <path d="M24 24H0V0h24v24z" fill="none" opacity=".87" />
              <path d="M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6-1.41-1.41z" />
            </svg>
          </button>
          <span class="font-sans text-xl font-semibold text-gray-600 px-2">TIPOS</span>
          <button
            title="Eliminar filtro de tipos"
            class="focus:outline-none"
            @click="clearFilter('types')"
          >
            <svg
              class="h-6 w-6 fill-current text-red-500 hover:text-red-700"
              viewBox="0 0 32 32"  
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="m30 11.414-1.414-1.414-4.586 4.586-4.586-4.586-1.414 1.414 4.586 4.586-4.586 4.585 1.415 1.415 4.585-4.586 4.587 4.586 1.413-1.413-4.586-4.587z"/>
              <path d="m4 4a2 2 0 0 0 -2 2v3.1709a2 2 0 0 0 .5859 1.4145l7.4141 7.4146v8a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2v-2h-2v2h-4v-8.8291l-.5859-.5855-7.4141-7.4145v-3.1709h20v2h2v-2a2 2 0 0 0 -2-2z"/>
              <path d="m0 0h32v32h-32z" fill="none"/>
            </svg>
          </button>

          <button
            title="Buscar por nombre de tipo"
            class="focus:outline-none"
            @click="toggleSearch({type: 'types'})"
          >
            <svg
              class="h-6 w-6 fill-current text-gray-500 hover:text-gray-700"
              viewBox="0 0 22 22"  
              xmlns="http://www.w3.org/2000/svg"
            >
              <<path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"/>
              <path d="m0 0h32v32h-32z" fill="none"/>
            </svg>
          </button>
          
        </div>
        <ul style="padding-left:30px;" class="mt-2" v-bind:class="[collapsed['types'] ? 'hidden' : 'block']">
          <li v-if="showSearch[`types`]">
            <label class="inline-flex items-center cursor-pointer text-gray-700 font-sans font-medium w-full pr-3" >
              <input
                type="text"
                ref="typesSearch"
                v-model="search['types']"
                placeholder="Búsqueda de tipo por nombre"
                class="w-full appearance-none border rounded py-2 px-3 mb-3 text-gray-900 bg-gray-200 focus:outline-none focus:bg-white focus:border-teal-500"
                @input="searchByName({ text: search['types'], type: 'types' })"
              />
            </label>
          </li>
          <template v-for="type in types">
            <li :key="type.id">
              <label class="inline-flex items-center cursor-pointer text-gray-700 font-sans font-medium">
                <input
                  type="checkbox"
                  class="form-checkbox"
                  :id="'type' + type.id"
                  name="type"
                  :value="type.id"
                  v-model="selectedType"
                  @change="fetchDataByFilter(type, $event)"
                />
                <span class="ml-2 mr-3">{{ type.nombre }}</span>
              </label>
            </li>
          </template>
        </ul>
      </div>
    </div>
  

  </div>
</template>

<script>
import { backend_url } from "../config/url.config.ts";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import { convertLength } from '@turf/helpers';

export default {
  name: "filter-explorer",
  data: function () {
    return {
      projects: [],
      categories: [],
      subcategories: [],
      types: [],
      selectedProject: [],
      selectedCategory: [],
      selectedSubcategory: [],
      selectedType: [], 

      selectedProjectID : [],
      selectedCategoryID: [],
      selectedSubcategoryID: [],
      selectedTypeID: [],

      isLoading: false,
      fullPage: true,

      collapsed: {
        projects: true,
        categories: true,
        subcategories: true,
        types: true, 
      },

      showSearch: {
        projects: false,
        categories: false,
        subcategories: false,
        types: false, 
      },

      search: {
        projects: "",
        categories: "",
        subcategories: "",
        types: "",
      },

      aux: {
        projects: [],
        categories: [],
        subcategories: [],
        types: []
      }
    };
  },
  components: {
     Loading
  },  
  props: {
    showing: {
      required: true,
      type: Boolean,
    },
  },
  methods: {
    fetchProjects() {
      this.axios
        .get(backend_url + "/api/ppd/proyectos/getProjectsToExplorer")
        .then((response) => {
          this.projects = response.data.proyectos;
        });
    },
    fetchCategories() {
      this.axios
        .get(backend_url + "/api/ppd/catprinc/getMainCategoriesToExplorer")
        .then((response) => {
          this.categories = response.data.categorias;
        });
    },
    fetchSubcategories() {
      this.axios
        .get(backend_url + "/api/ppd/subcategorias/getAllSubcategoriesToExplorer")
        .then((response) => {
          this.subcategories = response.data.subcategorias;
        });
    },
    fetchTypes() {
      this.axios
        .get(backend_url + "/api/ppd/tipolevantamiento/getTypesToExplorer")
        .then((response) => {
          this.types = response.data.tipos;
        });
    },
    fetchDataByFilter(item, e) {

      let data = {};
      this.isLoading = true;

      switch (e.target.name) {
        case "project":
          if(e.target.checked) { // si fue seleccionado, entonces
            this.selectedProjectID.push(item.id); //agrega su ID al arreglo de proyectos
          } else {
            let index = this.selectedProjectID.indexOf(item.id); //toma el id del proyecto en el  arreglo
            if(index > -1) { // si le id ya se encuentra en el arreglo, 
              this.selectedProjectID.splice(index, 1); // lo extrae de él
            }
          }
          break;
        case "category":
          if(e.target.checked) {
            this.selectedCategoryID.push(item.id);
          } else {
            let index = this.selectedCategoryID.indexOf(item.id);
            if(index > -1) {
              this.selectedCategoryID.splice(index, 1);
            }
          }
          break;
        case "subcategory":
          if(e.target.checked) {
            this.selectedSubcategoryID.push(item.id);
          } else {
            let index = this.selectedSubcategoryID.indexOf(item.id);
            if(index > -1) {
              this.selectedSubcategoryID.splice(index, 1);
            }
          }
          break;
        case "type":
          if(e.target.checked) {
            this.selectedTypeID.push(item.id);
          } else {
            let index = this.selectedTypeID.indexOf(item.id);
            if(index > -1) {
              this.selectedTypeID.splice(index, 1);
            }
          }
          break;
        default:
          console.log("otro")
          break;
      }

      if (this.selectedProject !== null) {
        data.id_proyecto = this.selectedProject;
      }
      if (this.selectedCategory !== null) {
        data.id_cat_principal = this.selectedCategory;
      }
      if (this.selectedSubcategory !== null) {
        data.id_cat_secundaria = this.selectedSubcategory;
      }
      if (this.selectedType !== null) {
        data.id_tipo = this.selectedType;
      }

      data.admin = localStorage.getItem("is_admin");

      if((this.selectedProject.length == 0) && (this.selectedCategory.length == 0) && (this.selectedSubcategory.length == 0) && (this.selectedType.length == 0)) {
        data.id_proyecto = [0]
        data.id_cat_principal = [0]
        data.id_cat_secundaria = [0]
        data.id_tipo = [0]

        // console.log(JSON.stringify(data))
        this.isLoading = false;
        this.axios
          .post(backend_url + "/api/ppd/levantamiento/getLevantamientos", data)
          .then((response) => {
            //this.showing = false;
            this.$emit("click", {
              levantamientos: response.data.levantamientos,
            });
            this.isLoading = false;
          });
      } else {
        // console.log(JSON.stringify(data))
        this.axios
          .post(backend_url + "/api/ppd/levantamiento/getLevantamientos", data)
          .then((response) => {
            //this.showing = false;
            this.$emit("click", {
              levantamientos: response.data.levantamientos,
            });
            this.isLoading = false;
          });
      }


    },
    clearFilter(filter) {
      // console.log(filter)
      // console.log(JSON.stringify(this.selectedProject))
      // console.log(JSON.stringify(this.selectedCategory))
      // console.log(JSON.stringify(this.selectedSubcategory))
      // console.log(JSON.stringify(this.selectedType))
      let data = {}
      if(this.selectedProject)
        data.id_proyecto = this.selectedProject
      if(this.selectedCategory)
        data.id_cat_principal = this.selectedCategory
      if(this.selectedSubcategory)
        data.id_cat_secundaria = this.selectedSubcategory
      if(this.selectedType)
        data.id_tipo = this.selectedType

      this.toggleSearch({type: filter, hidde: true});

      switch (filter) {
        case "projects":
          this.selectedProject = [];
          this.selectedProjectID = [];
          data.id_proyecto = [0]
          // console.log(JSON.stringify(data))
          this.axios
            .post(backend_url + "/api/ppd/levantamiento/getLevantamientos", data)
            .then((response) => {
              //this.showing = false;
              this.$emit("click", {
                levantamientos: response.data.levantamientos,
              });
              this.isLoading = false;
            });
          break;
        case "categories":
          this.selectedCategory = [];
          this.selectedCategoryID = [];
          data.id_cat_principal = []
          // console.log(JSON.stringify(data))
          this.axios
            .post(backend_url + "/api/ppd/levantamiento/getLevantamientos", data)
            .then((response) => {
              //this.showing = false;
              this.$emit("click", {
                levantamientos: response.data.levantamientos,
              });
              this.isLoading = false;
            });
          break;
          break;
        case "subcategories":
          this.selectedSubcategory = [];
          this.selectedSubcategoryID = [];
          data.id_cat_secundaria = []
          // console.log(JSON.stringify(data))
          this.axios
            .post(backend_url + "/api/ppd/levantamiento/getLevantamientos", data)
            .then((response) => {
              //this.showing = false;
              this.$emit("click", {
                levantamientos: response.data.levantamientos,
              });
              this.isLoading = false;
            });
          break;
          break;
        case "types":
          this.selectedType = [];
          this.selectedTypeID = [];
          data.id_tipo = []
          // console.log(JSON.stringify(data))
          this.axios
            .post(backend_url + "/api/ppd/levantamiento/getLevantamientos", data)
            .then((response) => {
              //this.showing = false;
              this.$emit("click", {
                levantamientos: response.data.levantamientos,
              });
              this.isLoading = false;
            });
          break;
          break;
      }
      if((this.selectedProject.length == 0) && (this.selectedCategory.length == 0) && (this.selectedSubcategory.length == 0) && (this.selectedType.length == 0)) {
        data.id_proyecto = [0]
        data.id_cat_principal = [0]
        data.id_cat_secundaria = [0]
        data.id_tipo = [0]

        // console.log(JSON.stringify(data))
        this.isLoading = false;
        this.axios
          .post(backend_url + "/api/ppd/levantamiento/getLevantamientos", data)
          .then((response) => {
            //this.showing = false;
            this.$emit("click", {
              levantamientos: response.data.levantamientos,
            });
            this.isLoading = false;
          });
      } 
      // console.log(JSON.stringify(this.selectedProject))
      // console.log(JSON.stringify(this.selectedCategory))
      // console.log(JSON.stringify(this.selectedSubcategory))
      // console.log(JSON.stringify(this.selectedType))

    },
    collapseFilter({ type = ''}) { 
      this.collapsed[type] = !this.collapsed[type];
      this.showSearch[type] = false;
      this.search[type] = '';
      if(this.aux[type].length !== 0) {
        this[type] = this.aux[type];
      }
    },
    setSelectedProject(project, e){
      console.log(JSON.stringify(this.selectedProject));
      console.log(project.id)
      console.log(JSON.stringify(this.selectedType));
      console.log(e.target)
      let data = {};

      if(e.target.checked) { // si fue seleccionado, entonces
        this.selectedProjectID.push(project.id); //agrega su ID al arreglo de proyectos
      } else {
        let index = this.selectedProjectID.indexOf(project.id); //toma el id del proyecto en el  arreglo
        if(index > -1) { // si le id ya se encuentra en el arreglo, 
          this.selectedProjectID.splice(index, 1); // lo extrae de él
        }
      }
      // this.collapseFilter('projects');
      data.admin = localStorage.getItem("is_admin");

      if (this.selectedProject !== null) {
        data.id_proyecto = this.selectedProject;
      }

      if (this.selectedCategory !== null) {
        data.id_cat_principal = this.selectedCategory;
      }
      if (this.selectedSubcategory !== null) {
        data.id_cat_secundaria = this.selectedSubcategory;
      }
      if (this.selectedType !== null) {
        data.id_tipo = this.selectedType;
      }

      this.axios
        .post(backend_url + "/api/ppd/levantamiento/getLevantamientos", data)
        .then((response) => {
          //this.showing = false;
          this.$emit("click", {
            levantamientos: response.data.levantamientos,
          });
          this.isLoading = false;
        });
    },
    setSelectedCategory(category, e){
      let data = {};

      if(e.target.checked) {
        this.selectedCategoryID.push(category.id);
      } else {
        let index = this.selectedCategoryID.indexOf(category.id);
        if(index > -1) {
          this.selectedCategoryID.splice(index, 1);
        }
      }
      // this.collapseFilter('categories')
      data.admin = localStorage.getItem("is_admin");

      if (this.selectedCategory !== null) {
        data.id_cat_principal = this.selectedCategory;
      }

      this.axios
        .post(backend_url + "/api/ppd/levantamiento/getLevantamientos", data)
        .then((response) => {
          //this.showing = false;
          this.$emit("click", {
            levantamientos: response.data.levantamientos,
          });
          this.isLoading = false;
        });

    },    
    setSelectedSubcategory(subcategory, e){
      let data = {};

        if(e.target.checked) {
          this.selectedSubcategoryID.push(subcategory.id);
        } else {
          let index = this.selectedSubcategoryID.indexOf(subcategory.id);
          if(index > -1) {
            this.selectedSubcategoryID.splice(index, 1);
          }
        }
        // this.collapseFilter('subcategories')
        data.admin = localStorage.getItem("is_admin");

        if (this.selectedSubcategory !== null) {
          data.id_cat_secundaria = this.selectedSubcategory;
        }

        this.axios
          .post(backend_url + "/api/ppd/levantamiento/getLevantamientos", data)
          .then((response) => {
            //this.showing = false;
            this.$emit("click", {
              levantamientos: response.data.levantamientos,
            });
            this.isLoading = false;
          });
      },
    setSelectedType(type, e){
    let data = {};
      if(e.target.checked) {
        this.selectedTypeID.push(type.id);
      } else {
        let index = this.selectedTypeID.indexOf(type.id);
        if(index > -1) {
          this.selectedTypeID.splice(index, 1);
        }
      }
      // this.collapseFilter('types')
      data.admin = localStorage.getItem("is_admin");

      if (this.selectedType !== null) {
        data.id_tipo = this.selectedType;
      }

      this.axios
        .post(backend_url + "/api/ppd/levantamiento/getLevantamientos", data)
        .then((response) => {
          //this.showing = false;
          this.$emit("click", {
            levantamientos: response.data.levantamientos,
          });
          this.isLoading = false;
        });
    },

    activateCheckboxes() {
      
      // querySelector('input[name="pwd"]')
      var projectsList = document.querySelectorAll('input[type="checkbox"]')
      // console.log(JSON.stringify(projectsList))

    },

    toggleSearch({ type = ``, hidde = false }) {
      this.showSearch[type] = hidde ? false : !this.showSearch[type];
      if(this.collapsed[type]){
        this.collapsed[type] = false;
      }
      if(this.aux[type].length !== 0) {
        if(!this.showSearch[type]){
          this.search[type] = '';
          this[type] = this.aux[type];
        } 
      }

      if (this.showSearch[type]) {
        this.$nextTick(() => {
          const refName = `${type}Search`;
          this.$refs[refName].focus();
        });
      }
    },

    searchByName({ text = '', type = `` }) {
      if (this[type] && Array.isArray(this[type])) {
        if(this.aux[type].length === 0)
          this.aux[type] = this[type];

        this[type] = this.aux[type].filter(item =>
          item.nombre.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").includes(
            text.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "")
          )
        );
      }
    }            
  },
  mounted() {
    this.fetchProjects();
    this.fetchCategories();
    this.fetchSubcategories();
    this.fetchTypes();
  },
  created: function() {
    this.activateCheckboxes();
  }
};
</script>

<style scoped>

input[type="checkbox"] {
  /* Add if not using autoprefixer */
  -webkit-appearance: none;
  /* Remove most all native input styles */
  appearance: none;
  /* Not removed via appearance */
  margin: 0;
  font: inherit;
  background-color: #f7fafc;
  color: #0ea5e9;
  width: 1.15em;
  height: 1.15em;
  border: 0.10em solid #0284c7;
  border-radius: 0.30em;
  transform: translateY(-0.075em);

  display: grid;
  place-content: center;
}

input[type="checkbox"]::before {
  content: "";
  width: 0.65em;
  height: 0.65em;
  clip-path: polygon(14% 44%, 0 65%, 50% 100%, 100% 16%, 80% 0%, 43% 62%);
  transform: scale(0);
  transform-origin: bottom left;
  transition: 120ms transform ease-in-out;
  box-shadow: inset 1em 1em var(--form-control-color);
  /* Windows High Contrast Mode */
  background-color: #0284c7;
}

input[type="checkbox"]:checked::before {
  transform: scale(1);
}

.bg-filters {
  background: #fff;
  min-height: fit-content;
  max-height: fit-content;
  overflow: hidden;
}

.scrollable-items {
  min-height: 20vh;
  max-height: 75vh;
}

.overflow-auto::-webkit-scrollbar {
  width: 8px;
}

/* track */
.overflow-auto::-webkit-scrollbar-track {
  box-shadow: inset 0 0 2px #f7fafc;
  border-radius: 15px;
}

/* handle (barrita que se mueve)*/
.overflow-auto::-webkit-scrollbar-thumb{
  background: #b3b3b3;
  border-radius: 15px;
}

/* handle (barrita que se mueve)*/
.overflow-auto::-webkit-scrollbar-thumb:hover{
  background: #797979;
}

</style>